import React, { useEffect, useState } from "react";
import NewHeader from "../NavBar/newHeader";
import HeadWithSubHead from "../../common/HeadWithSubHead";
import styles from "./OfflineTransaction.module.css";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import CommonButton from "../../component/CommonButton/CommonButton";
import FileUploader from "../../component/onboarding/studentDetails/fileUpload";
import { useMyContext } from "../../myContext";
import {
  documentPurposeUpload,
  getDocToBeUpload,
  offlineSubmitTransaction,
} from "../../api";
import { useNavigate } from "react-router";

function OfflineDocuments() {
  const [docRequired, setDocRequired] = useState([]);
  const [requiredDoc, setRequiredDoc] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [loading, setLoading] = useState();
  const { themeColor } = useMyContext();
  const [loader, setLoader] = useState(false);
  const [transId, setTransId] = useState();
  const [messageToDisplay, setMessageToDisplay] = useState("");
  const acceptedFormats = ".jpeg, .jpg, .png, .pdf";
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (sessionStorage.getItem("offlineUserStatus") !== "offlineDocuments") {
      navigate("/transaction-detail", { replace: true });
      window.location.reload();
    }
    setTransId(sessionStorage.getItem("offlineTransactionId"));
  }, []);

  useEffect(() => {
    if (docRequired.length === 0 && requiredDoc.length > 0) {
      setLoading(false);
      const requiredDocs = requiredDoc.filter(
        (doc) => !doc.isOptional
      );
      const optionalDocs = requiredDoc.filter(
        (doc) => doc.isOptional
      );

      const sortedDocs = [...requiredDocs, ...optionalDocs].map((doc) => ({
        label: doc.docName,
        file: [],
        isRequired: doc.isOptional ? false : true,
        internalLabel: doc.docType,
      }));

      setDocRequired(sortedDocs);
    }
  }, [docRequired, requiredDoc]);

  useEffect(() => {
    if (transId !== "" && transId !== undefined) {
      setLoading(true);
      const docToUpload = async () => {
        let resp = await getDocToBeUpload(transId);
        setLoading(false);
        if (resp.status === 200 && resp.data.length > 0) {
          setRequiredDoc(resp.data);
        }
      };
      docToUpload();
    }
  }, [transId]);

  useEffect(() => {
    const areAllFilesUploaded = docRequired.every((data) => {
      return data.isRequired
        ? data.file && Object.keys(data.file).length > 0
        : true;
    });
    setButtonDisabled(!areAllFilesUploaded);
  }, [docRequired]);
  const uploadFile = async (file, fileName, fileType, docType, side) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await documentPurposeUpload(
        transId,
        "",
        fileName,
        fileType,
        docType,
        formData,
        side
      );
      handleSuccess(response);
    } catch (error) {
      handleError(error);
      throw error;
    }
  };
  const handleSuccess = (res) => {
    if (res.status === 200) {
    }
  };
  const handleError = (error) => {};

  const handleRemoveButton = (label) => {
    setDocRequired((prevDocRequired) => {
      return prevDocRequired.map((data) => {
        if (data.label === label) {
          return {
            ...data,
            fileType: "",
            file: null,
            docType: "",
          };
        }
        return data;
      });
    });
  };

  const submitDocument = async () => {
    setLoader(true);
    try {
      const body = {
        transactionId: transId,
      };
      const resp = await offlineSubmitTransaction(body);
      if (resp?.status === 200) {
        setMessageToDisplay(
          "You will be navigated to the Transaction Screen shortly. Please complete your Bank Transfer and submit the UTR number."
        );
        setTimeout(() => {
          setMessageToDisplay("");
          navigate("/transaction-detail");
        },[5000])
      } else {
        setErrorMessage(
          resp?.data?.message !== ""
            ? resp?.data?.message
            : "Something went wrong, please try again later"
        );
      }
    } catch (e) {
      setErrorMessage("Something went wrong, please try again later");
      setLoader(false);
    }
  };

  const uploadAllFiles = async () => {
    setErrorMessage("");
    setLoader(true);
    setButtonDisabled(true);
    try {
      const uploadPromises = docRequired.map(async (data) => {
        var side = "";
        if (data.docType === "PASSPORT_FRONT") {
          side = "front";
        }
        if (data.docType === "PASSPORT_BACK") {
          side = "back";
        }
        if (
          data.docType === "PASSPORT_FRONT" ||
          data.docType === "PASSPORT_BACK"
        ) {
          data.docType = "PASSPORT";
        }
        if (data.file && Object.keys(data.file).length > 0) {
          await uploadFile(
            data.file,
            data.docType,
            data.fileType,
            data.docType,
            side
          );
        }
      });
      await Promise.all(uploadPromises);
      submitDocument();
      setButtonDisabled(false);
      setErrorMessage("");
    } catch (error) {
      setLoader(false);
      setErrorMessage("Error while Uploading File");
    }
  };

  const checkValidFile = (files) => {
    if (
      files.filter(
        (file) =>
          acceptedFormats.includes(file.type) ||
          acceptedFormats.includes(`.${file.name.split(".").pop()}`)
      )
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleDrop = (files, label) => {
    if (checkValidFile(files)) {
      const fileExtension = files[0].name.split(".").pop();
      setDocRequired((prevDocRequired) => {
        return prevDocRequired.map((data) => {
          if (data.label === label) {
            return {
              ...data,
              fileType: fileExtension,
              file: files[0],
              docType: data.internalLabel,
            };
          }
          return data;
        });
      });
    }
  };

  return (
    <>
      <NewHeader show={true} />
      <div className={`container ${styles.outermainContainer}`}>
        <HeadWithSubHead
          head={"Document Upload"}
          subHead="Upload the Required Docs related to your purpose"
        />
        <Card className={styles.cardBorder} style={{ minHeight: "345px" }}>
          {messageToDisplay !== "" ? (
            <div className={styles.paymentWaiting}>
               <Spinner
                    animation="border"
                    className={styles.spinnerColor}
                    style={{
                      width: "28px",
                      height: "28px",
                      borderColor: themeColor,
                      borderRightColor: "#eaecf0",
                    }}
                  />
            <p className={styles.message}>{messageToDisplay}</p> 
            </div>
          ) : (
            <>
              <div style={{ marginTop: "20px" }}>
                {loading ? (
                  <Spinner
                    animation="border"
                    className={styles.spinnerColorOutside}
                    style={{
                      borderColor: themeColor,
                      borderRightColor: "#eaecf0",
                    }}
                  />
                ) : (
                  <Row
                    style={{ marginBottom: "8px", justifyContent: "center" }}
                  >
                    {docRequired.map((data, index) => {
                      return (
                        <>
                          <Col
                            key={index}
                            md={3}
                            xs={8}
                            lg={3}
                            className={styles.fileStyling}
                          >
                            <FileUploader
                              onDrop={handleDrop}
                              acceptedFormats={acceptedFormats}
                              maxSize={5000000}
                              label={data.label}
                              sublabel={ data.isRequired === false
                                  ? "(Optional)"
                                  : ""
                              }
                              loading={loader}
                              onRemoveButton={handleRemoveButton}
                            />
                          </Col>
                        </>
                      );
                    })}
                  </Row>
                )}
              </div>
              <Row className={styles.allowedFormat}>
                {/* Allowed Formats are jpeg,png,jpg,pdf and the size should be less
              then 5MB */}
                <p className={styles.allowedFormatheading}>Allowed Formats</p>
                <p className={styles.allowedFormatsubheading}>
                  JPEG, PNG, JPG or PDF (max. size 5MB)
                </p>
              </Row>
              {errorMessage !== "" && (
                <p className={styles.errorMessage}>{errorMessage}</p>
              )}
              <Row className={styles.ProceedButtton}>
                <CommonButton
                  title="Confirm Upload"
                  onClick={() => uploadAllFiles()}
                  loading={loader}
                  disabled={buttonDisabled || loading || loader}
                  width={"261px"}
                />
              </Row>
            </>
          )}
        </Card>
      </div>
    </>
  );
}

export default OfflineDocuments;
